export default {
      id: "i-features-05-usage",
      viewBox: "0 0 21 23",
      url: __webpack_public_path__ + "img/sprite.svg#i-features-05",
      toString: function () {
        return this.url;
      }
    }